module.exports = __webpack_public_path__ + "img/video-inline-icon.b43a98f7.png";